import { push } from 'react-router-redux';
import { createUseBoundEventCreator } from '@dbh/redux-extra';

const useReactRouterUrlPushed=createUseBoundEventCreator(push);

export { useReactRouterUrlPushed as default };
